/* eslint-disable jsx-a11y/alt-text */

/**
 * Componente para visualizar imagens
 * @module ImageView
 * @category Componentes
 */

import React from 'react';
import { Dialog } from 'primereact/dialog';
import PropTypes from 'prop-types';

import { Container } from './styles';
import ButtonSp from '../ButtonSp';
import { errorHandle, saveImageFromBase64 } from '../../util/functions';

/**
 * @typedef ImageViewProps
 * @property {boolean} visible Flag para mostrar ou não a tela do ImageView
 * @property {function} setVisible Handle para controle do visible
 */

/**
 * Componente ImageView
 * @func ImageView
 * @param {ImageViewProps} props Propriedades
 */
export default function ImageView(props) {
  ImageView.propTypes = {
    title: PropTypes.string,
    src: PropTypes.string,
    visible: PropTypes.bool,
    setVisible: PropTypes.func,
  };

  ImageView.defaultProps = {
    title: '',
  };

  const { title, src, visible, setVisible } = props;

  return (
    <Container>
      <Dialog
        closable
        closeOnEscape
        header={title}
        visible={visible}
        contentStyle={{ margin: 0, padding: 0 }}
        style={{ minWidth: '350px' }}
        modal
        blockScroll
        onHide={() => {
          if (setVisible) {
            setVisible(false);
          }
        }}
      >
        <ButtonSp
          className="p-button-secondary buttons btn-download"
          title="Baixar Arquivo"
          label=""
          keyAccess="I"
          icon="pi pi-download"
          type="button"
          onClick={() => {
            const imageType = src.split(';')[0].split(':')[1];
            if (!imageType) {
              errorHandle('Não foi possível obter o tipo de arquivo');
            }
            const extensao = imageType.split('/')[1];

            saveImageFromBase64(src, imageType, `imagem.${extensao}`);
          }}
        />

        <img
          src={src}
          frameBorder="0"
          scrolling="auto"
          style={{ maxWidth: 1024 }}
          className="responsive"
        />
      </Dialog>
    </Container>
  );
}
